export default "__VITE_ASSET__1b19a59d__"